import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@salesforce/design-system-react';

const SubHeader = (props) => {
    return (
        <div className="slds-grid sidebar-subheader slds-p-horizontal_small slds-p-vertical_xx-small">
            <div className="slds-size_1-of-12">
                {props.score === 100 ? (<Icon category="action" name="approval" size="xx-small" style={{ fill: '#4bca81', backgroundColor: 'none'}}/>)  :  (null)}
            </div>
            <div 
                className="slds-size_10-of-12  slds-p-top_xx-small"
                style={{ cursor: 'pointer'}}
            >
                <a href={props.redirectUrl} className="slds-p-left_small slds-m-top_small">{props.title}</a>
            </div>
            <div className="slds-size_1-of-12 slds-align_absolute-center">
                {props.expand === false ? (null) : 
                (<Button
                    iconCategory="utility"
                    iconName={ props.isOpen ? "dash" : "add"}
                    iconPosition="right"
                    variant="link"
                    style={{ color: 'white'}}
                    onClick={props.isOpen ? () => props.setIsOpen(false) : () => props.setIsOpen(true)}
                />)}
            </div>
        </div>
    );
}

SubHeader.propTypes = {
    score: PropTypes.number.isRequired,
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    setIsOpen: PropTypes.func.isRequired,
};
  
export default SubHeader;